export default {
  name: '',
  description: '',
  scenario_slug: null,
  settings: {
    'greeting.new_client.operator_online': '',
    'greeting.new_client.operator_offline': '',
    'greeting.existing_client.operator_online': '',
    'greeting.existing_client.operator_offline': '',
    'email.receivers_list': [],
    'email.notify.new_sessions': false,
    'email.notify.assignment': false,
    'email.notify.manual_dialog_switch': false,
    'email.notify.operator_unavailable': false,
    'auto_close_period': '1800',
    'auto_assignment.slug': null,
    'allow_scenario_interruption_by_operator': false,
    'e2e.enabled': false
  }
}
